
export let notes = [
  "C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"
];
export let octaves = [2,3,4,5];
// g3, b2 or a#2
let allNotes = [1,2,3,4,5,6].map((i) => notes.map((n) => `${n}${i}`)).flat();
console.log(allNotes);
let madhyaNotes = ["s", "r1", ["r2","g1"], ["g2","r3"], "g3", "m1", "m2", "p","d1", ["d2","n1"], ["n2","d3"], "n3"];
let mandaraNotes = madhyaNotes.map((swara) => {
  if (swara instanceof Array){
    return {swara: swara[0]+".", altSwara :swara[1]+".", sthana: "mandara"};
  }
  return {swara: swara+".", sthana: "mandara"};
});
let taraNotes = madhyaNotes.map((swara) => {
  if(swara instanceof Array){
    return {swara: swara[0].toUpperCase(), altSwara :swara[1].toUpperCase(), sthana: "taara"};
  }
  return {swara: swara.toUpperCase(), sthana: "taara"};
});
let madhya = madhyaNotes.map((swara) => {
  if(swara instanceof Array){
    return {swara: swara[0], altSwara :swara[1], sthana: "madhya"};
  }
  return {swara: swara, sthana: "madhya"};
});
let indianNotes=mandaraNotes.concat(madhya).concat(taraNotes);
console.log("Indian Notes: ", indianNotes);

export function deriveScale(rootNote, octave) {
  let rootNoteIdx = allNotes.indexOf(`${rootNote}${octave}`);
  console.log(rootNoteIdx);
  let scale = allNotes.slice(rootNoteIdx-madhyaNotes.length, rootNoteIdx-madhyaNotes.length+indianNotes.length);
  let swaras = indianNotes.map((swaraObj, idx) => {
    swaraObj.note = scale[idx];
    return swaraObj;});
   return swaras;
  //return indianNotes.map((iNote, idx) => [iNote, scale[idx]]);
}

export const ragas = [
  {
    name: "Mohanam",
    murchana: "s r2 g3 p d2 S S d2 p g3 r2 s",
    korvai: "g3 , g3 , r2 , , , s s r2 r2 g3 g3 r2 r2" 
  },
  {
    name: "Abhogi",
    murchana: "s r2 g2 m1 d2 S S d2 m1 g2 r2 s",
    korvai: "r2 , g2 , g2 r2 s , s r2 s s d2. m1. d2. ," 
  },
  {
    name: "Dheera Shankarabharanam",
    murchana: "s r2 g3 m1 p d2 n3 S S n3 d2 p m1 g3 r2 s",
    korvai: "s m1 g3 m1 p , d2 n3 S R2 n3 S d2 n3 S" 
  },
  {
    name: "MayamalaGowla",
    murchana: "s r1 g3 m1 p d1 n3 S S n3 d1 p m1 g3 r1 s",
    korvai: "s r1 g3 m1 , p d1 p m1 g3 , m1 , g3 r1 s" 
  },
]
/*
const reducer = (acc, currentValue) => {
  acc[currentValue[0]]=currentValue[1];
  return acc;
}

//swaras is an array of objects. Each object has a swara, note, sthana
// window.swaras = swaras;
/*
const s = [
  {
    swara: "g2.",
    note: "f3",
    type: "mandara",
    altSwara: "r3"
  },
  {
    name: "m1.",
    note: "g3",
    type: "mandara"
  },
  {
    name: "m1.",
    note: "g3",
    type: "mandara"
  },
]
*/
/*const swaras = { 
  'r1.' : 'A#4',
  'r2.' : 'B4',
  'g2.' : 'C4',
  'g3.' : 'C#4',
  'm1.' : 'D4',
  'm2.' : 'D#4',
  'p.' : 'E4',
  'd1.' : 'F4',
  'd2.' : 'F#4',
  'n2.' : 'G4',
  'n3.' : 'G#4',
  s : 'A4',
  r1 : 'A#4',
  r2 : 'B4',
  g2 : 'C5',
  g3 : 'C#5',
  m1 : 'D5',
  m2 : 'D#5',
  p : 'E5',
  d1 : 'F5',
  d2 : 'F#5',
  n2 : 'G5',
  n3 : 'G#5',
  S : 'A5',
  R1 : 'A#5',
  R2 : 'B5',
  G2 : 'C6',
  G3 : 'C#6',
  M1 : 'D6',
  M2 : 'D#6',
  P : 'E6',
  D1 : 'F6',
  D2 : 'F#6',
  N2 : 'G6',
  N3 : 'G#6'
}
*/

/*
const ragas = {
  "Mohanam": "s r2g1 g3 p d2n1 S S d2n1 p g3 r2g1 s",
  "Abhogi": "s r2 g2 m1 d2 S S d2 m1 g2 r2 s",
  "DS": "s r2 g3 m1 p d2 n3 S S n3 d2 p m1 g3 r2 s",
  "Mayamalavagowla" : "s r1 g3 m1 p d1 n3 S S n3 d1 p m1 g3 r1 s"
};
*/


/*
const phrases = {
  "Mohanam": "g3 , g3 , r2g1 , , , s s r2g1 r2g1 g3 g3 r2g1 r2g1",
  "Abhogi": "r2g1 , g2r3 , g2r3 r2g1 s , s r2g1 s s d2n1. m1. d2n1. ,",
  "DS" : "s m1 g3 m1 p , d2n1 n3",
  "Mayamalavagowla": "s r1g2 g3 m1 , p d1 p m1 g3 ,"
}
*/

/*
module.exports = {
  ragas, swaras
};*/